import { applyKuulaBranding, isKuulaUrl, type KuulaOverrides } from "@/lib/kuulaConfig";

const MOTION_PARAMS = ["gyro", "gyroscope", "accelerometer", "deviceorientation", "motion", "tilt"];
const MOBILE_BREAKPOINT = 768;

/** Normalise a raw tour URL into a valid embed src.
 *  – kuula.co/post/XXX  → kuula.co/share/XXX
 *  – kuula.co/share/…   → kept as-is
 *  – kuula.co/embed/…   → kept as-is
 *  – non-Kuula URLs     → returned unchanged
 */
export function normalizeKuulaUrl(raw: string): string {
  if (!raw) return "";
  const s = raw.trim();
  if (!isKuulaUrl(s)) return s;
  // Convert /post/ links to /share/ (post URLs don't embed)
  const postMatch = s.match(/kuula\.co\/post\/([A-Za-z0-9]+)/i);
  if (postMatch) {
    try {
      const parsed = new URL(s);
      parsed.pathname = `/share/${postMatch[1]}`;
      return parsed.toString();
    } catch {
      return `https://kuula.co/share/${postMatch[1]}`;
    }
  }
  return s;
}

export function isMobileDevice(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export function withMotionDisabled(url: string): string {
  try {
    const parsed = new URL(url);
    MOTION_PARAMS.forEach((param) => parsed.searchParams.set(param, "0"));
    return parsed.toString();
  } catch {
    return url;
  }
}

export function withMotionEnabled(url: string): string {
  return withMotionDisabled(url);
}

export function buildTourUrl(url: string, _gyroEnabled = false, kuulaOverrides: KuulaOverrides = {}): string {
  const normalized = normalizeKuulaUrl(url);
  return withMotionDisabled(applyKuulaBranding(normalized, kuulaOverrides));
}
